module.exports = __webpack_public_path__ + "fonts/constantia.ce4f7b8.woff2";